import { DataProvider } from "badmfck-signal";
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider";
import { GD } from "../GD";
import { ProjectRole } from "../permissions";

export type TProjectType = "service" | "merchant" | "global";
export interface IProject {
	id: number;
	name: string;
	roles: ProjectRole[];
}

export class Projects {
	projects: DataProvider<void, IProject[]> = new DataProvider({ cacheTime: 0 }, "Projects");
	currentProject: IProject | null = null;

	constructor() {
		this.projects.setExecutor(async _ => {
			const response = (await GD.REQ_API.request({ method: "projects/get", data: {} })) as IExecutorResponse<IProject[]>;
			return response;
		});

		GD.B_PROJECTS.onRequest(async _ => {
			this.projects.reset();
			GD.B_PROJECTS.invoke(await this.projects.load());
		});
		GD.B_SELECTED_PROJECT.onRequest(async _ => GD.B_SELECTED_PROJECT.invoke(this.currentProject));

		GD.REQ_PROJECT_ID_BY_NAME.listener = async req => {
			const projects = await this.projects.load();
			if (projects.error || !projects.data) return 0;
			return projects.data.find(p => p.name === req)?.id ?? 0;
		};

		GD.REQ_PROJECT_BY_ID.listener = async req => {
			if (!req) return null;
			const projects = await this.projects.load();
			if (projects.error || !projects.data) return null;
			if (!req) {
				console.error("REQ_PROJECT_BY_ID: request is not defined");
				return null;
			}
			return projects.data.find(p => p.id === req.projectID) ?? null;
		};

		GD.S_PROJECT_SELECTED.subscribe(p => {
			this.currentProject = p;
		});

		GD.REQ_CURRENT_PROJECT.listener = async () => this.currentProject;

		GD.REQ_PROJECT_SAVE.listener = async req => {
			if (!req) return null;

			const result = await GD.REQ_API.request({ method: "projects/save", data: req });
			if (result.error) return result.error;

			this.projects.reset();
			GD.B_PROJECTS.invoke(await this.projects.load());

			return result.data as IProject;
		};
	}
}
